import { FDealType } from '../../../../../JsonQuery';
import {
  OFFER_TYPES_RENT_RESIDENTIAL,
  OFFER_TYPES_SALE_RESIDENTIAL,
  OFFER_TYPES_DAILY_RESIDENTIAL,
} from './constants/offerTypes';
import { IOfferType } from './types';

const OFFER_TYPES: { dealType: FDealType; list: IOfferType[][] }[] = [
  {
    dealType: FDealType.Sale,
    list: OFFER_TYPES_SALE_RESIDENTIAL,
  },
  {
    dealType: FDealType.RentLongterm,
    list: OFFER_TYPES_RENT_RESIDENTIAL,
  },
  {
    dealType: FDealType.RentDaily,
    list: OFFER_TYPES_DAILY_RESIDENTIAL,
  },
];

export function getOfferTypeList(dealType: FDealType): IOfferType[][] {
  const type = OFFER_TYPES.find(t => t.dealType === dealType);

  return (type && type.list) || [];
}
